import * as React from 'react';
import { fetchCountryList, selectIsFetchingCountryList, selectIsLoadedCountryList } from '@gandi/redux-places';
import { jsx as _jsx } from "react/jsx-runtime";
const fetchCountryListIfNeeded = (dispatch, getState) => {
  const state = getState();
  const fetching = selectIsFetchingCountryList(state);
  const loaded = selectIsLoadedCountryList(state);
  if (!loaded && !fetching) {
    return dispatch(fetchCountryList());
  }
};
function CountryName({
  country,
  countryName,
  dispatch
}) {
  React.useEffect(() => {
    dispatch(fetchCountryListIfNeeded);
  }, [dispatch]);
  return /*#__PURE__*/_jsx("span", {
    children: countryName || country
  });
}
CountryName.preFetch = ({
  dispatch,
  getState
}) => fetchCountryListIfNeeded(dispatch, getState);
export default CountryName;